import { useEffect, useState } from 'react';
import { OrganizationDocument, useFirebaseService } from '../../../data/FirebaseService';
import { Card, CardContent, Input, Switch, Typography } from '@mui/material';
import LogoUpload from './LogoUpload';

const SettingsPage: React.FC = () => {
    const [organization, setOrganization] = useState<OrganizationDocument | null>(null);
    const firebaseService = useFirebaseService();

    useEffect(() => {
        if (firebaseService) {
            const fetchOrganization = async () => {
                const organization = await firebaseService.getOrganizationDocument();
                setOrganization(organization);
            };

            fetchOrganization();
        }
    }, [firebaseService]);

    return (
        <div>
            <Typography variant="h5" component="h2" className='page-title'>Settings</Typography>
            {organization && (
                <>
                    <Card sx={{ p: 2, textAlign: "left" }}>
                        <CardContent>
                            <Typography variant="h6">General</Typography>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                <Typography variant="subtitle1" component="h3" style={{ marginRight: '10px', width: '200px' }}>Organization ID:</Typography>
                                <Input id="organization-id" value={organization.id} readOnly />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                <Typography variant="subtitle1" component="h3" style={{ marginRight: '10px', width: '200px' }}>Organization Name:</Typography>
                                <Input id="organization-id" value={organization.name} readOnly />
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                <Typography variant="subtitle1" component="h3" style={{ marginRight: '10px', width: '200px' }}>Expiry Date:</Typography>
                                <Input id="organization-id" value={organization.expiryDate.toDate().toDateString()} readOnly />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                <Typography variant="subtitle1" component="h3" style={{ marginRight: '10px', width: '200px' }}>Account Type:</Typography>
                                <Input id="organization-id" value={organization.tier === "trial" ? 'Trial' : 'Paid'} readOnly />
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                <Typography variant="subtitle1" component="h3" style={{ marginRight: '10px', width: '200px' }}>App Registration Key:</Typography>
                                <Input id="organization-id" value={organization.registrationKey} readOnly style={{ width: '300px' }} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                <Typography variant="subtitle1" component="h3" style={{ marginRight: '10px', width: '200px' }}>
                                    App Self-registration:
                                </Typography>
                                <Switch
                                    checked={organization.isSelfSignupAllowed}
                                    onChange={async (e) => {
                                        const updated = { ...organization, isSelfSignupAllowed: e.target.checked };
                                        setOrganization(updated);
                                        if (firebaseService) {
                                            await firebaseService.updateOrganizationDocument({ isSelfSignupAllowed: e.target.checked });
                                        }
                                    }}
                                    inputProps={{ 'aria-label': 'Self Signup Allowed' }}
                                />
                            </div>

                        </CardContent>
                    </Card>
                    <div style={{ margin: '20px 0' }} />
                    <Card sx={{ p: 2, textAlign: "left" }}>
                        <CardContent>
                            <Typography variant="h6">Branding</Typography>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                <Typography variant="subtitle1" component="h3" style={{ marginRight: '10px', width: '200px' }}>Logo:</Typography>
                                {organization.logoUrl && (<img src={organization.logoUrl} alt="Organization Logo" style={{ maxHeight: '50px', paddingRight: '10px' }} />)}
                                <LogoUpload />
                            </div>
                        </CardContent>
                    </Card>

                </>
            )}

        </div>
    );
};

export default SettingsPage;